import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

const BottomBar = () => {
  const { t } = useTranslation();

  const svgs = Array(5)
    .fill(null)
    .map((_, index) => (
      <svg
        key={index}
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
      >
        <path
          d="M2.28858 11.4044L3.27339 7.18607L0 4.3511L4.3114 3.97698L6 0L7.6886 3.97698L12 4.3511L8.7266 7.18607L9.71142 11.4044L6 9.16483L2.28858 11.4044Z"
          fill="black"
        />
      </svg>
    ));

  return (
    <div className={styles.bottomBar}>
      <div className={styles.starsWrapper}>{svgs}</div>
      <p>
        “{t("allMyLife")}”
      </p>
    </div>
  );
};

export default BottomBar;
